const verification_record = {
    not_found: 'Verification record not found.',
    permission_denied: 'Permission denied, please re-authenticate.',
    not_supported_for_google_one_tap: 'This API does not support Google One Tap.',
};
export default Object.freeze(verification_record);
